import { LitElement, html, svg } from 'lit';

export class IconAds32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Ark med bilde og overskrift</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M25 7H7v7h18V7ZM7 22h18"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 2h24a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"></path></svg>`; }
}
if (!customElements.get('f-icon-ads32', IconAds32)) {
  customElements.define('f-icon-ads32', IconAds32);
}